import { inject } from "@angular/core";
import { ResolveFn, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr'
import { UserDetailsService } from '../services/user-details.service';

export const EmailUnsubscribePermissionResolver: ResolveFn<any> = async (
  _route,
  _state,
  userDetail = inject(UserDetailsService),
  router: Router = inject(Router),
  Toastrservice = inject(ToastrService)
) => {
    const val: string | null = localStorage.getItem('isUserLoggedIn');
    if (val == 'true') {
        let params:any = _route.queryParams
        if(userDetail.userId === parseInt(params.user_id)){
            router.parseUrl('/unsubscribe');
        }else{
            Toastrservice.error('You are unauthorized')
            router.navigate(["/dashboard"])
        }
    } else {
        Toastrservice.error('Please login to your account')
        router.navigate(["/"])
    }
};